<template>
  <div :class="classes">
      <pt-page-title title="健康档案详情" ></pt-page-title>
      <pt-sub-title title="健康档案信息"></pt-sub-title>
      <!-- <div :class="$style['pt-health-record-detail-table']"> -->
      <table>
        <pt-message-table-item label="姓名">
            {{healthRecordDetail.name}}
        </pt-message-table-item>
        <pt-message-table-item label="姓别">
            {{healthRecordDetail.sex}}
        </pt-message-table-item>
         <pt-message-table-item label="证件类型">
            {{healthRecordDetail.idCardType}}
        </pt-message-table-item>
        <pt-message-table-item label="证件号码">
            {{healthRecordDetail.identityCard}}
        </pt-message-table-item>
        <pt-message-table-item label="生日">
            {{healthRecordDetail.birthday_date}}
        </pt-message-table-item>
        <pt-message-table-item label="照片分类">
            {{healthRecordDetail.record_type}}
        </pt-message-table-item>
        <pt-message-table-item label="照片">
            <template  v-if="healthRecordDetail.recordImage&&healthRecordDetail.recordImage.length>0">
            <div :class="$style['health-record-imgs']">
                <div  v-for="(item,index) in healthRecordDetail.recordImage" :key="index" :class="$style['health-record-img-item']">
                    <pt-img @click.native="onPreview(index)" :class="$style['picture-radius']" :isPublic="false" :src="item"></pt-img>
                </div>
            </div>
            </template>
        </pt-message-table-item>
         <pt-message-table-item label="创建时间">
            {{healthRecordDetail.created_date}}
        </pt-message-table-item>
         <pt-message-table-item label="摘要">
            {{healthRecordDetail.note}}
        </pt-message-table-item>
      </table>
      <!-- </div> -->
        <wt-image-preview v-if="previewVisible" @close-preview="closePreview" :initialIndex="currentIndex" :value="images" :loop="false"></wt-image-preview>
  </div>
</template>

<script>
// 组件class前缀
const prefixCls = 'pt-health-record-detail'

export default {
  name: 'pt-health-record-detail',
  computed: {
    classes () {
      return `${prefixCls}`
    }
  },
  props: {
    id: {
      type: String,
      default: ''
    },
    healthRecordDetail: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
      images: '',
      previewVisible: false,
      privateResourcesUrl: this.$privateResourcesUrl,
      currentIndex: 0
    }
  },
  methods: {
    onPreview (index) {
      this.images = []
      this.healthRecordDetail.recordImage.forEach(item => {
        this.images.push(this.privateResourcesUrl + item)
      })
      this.previewVisible = true
      this.currentIndex = index
    },
    closePreview () {
      this.previewVisible = false
    }
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */

.picture-radius{
    border-radius:5px;
    height: auto
}
.health-record-imgs{
    display: flex;
    white-space:normal!important;
    flex-wrap:wrap;
    justify-content: flex-start!important;
}
.health-record-img-item{
    max-width: 200PX;
    max-height: 200PX;
    padding-right: 10px;
    margin-bottom: 10px;
    display: block;
    div{
        max-height: 100%;
        display: block!important;
    }
    img{
        max-width: 100%;
        max-height: 200PX;
        display: block!important;
        border-radius: 10px;
    }
}
.pt-health-record-detail-table{
    width: 100%
}
</style>
<style lang="less">
.pt-health-record-detail{
    table{
        padding:20px;
        table-layout:fixed;
        tr{

        }
    }
}
</style>
